import React from "react";
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { HeaderProps } from "src/utils/interfaces";

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  let botonIzq: React.ReactNode | null = null;
  if (props.botonIzq) {
    botonIzq = (
      <IonButton routerLink={props.botonIzq.url} onClick={props.botonIzq.action}>
        <IonIcon
          slot="icon-only"
          icon={props.botonIzq.icono}
          src={props.botonIzq.src}
          title="btnIzq"
        ></IonIcon>
      </IonButton>
    );
  }
  let botonesDerecha: React.ReactNode | null = null;
  if (props.botonesDerecha) {
    botonesDerecha = props.botonesDerecha.map((boton, idx) => (
      <IonButton key={idx} routerLink={boton.url} onClick={boton.action}>
        <IonIcon title="btnDerecha" slot="icon-only" icon={boton.icono} src={boton.src}></IonIcon>
      </IonButton>
    ));
  }

  return (
    <IonHeader>
      <div className="container px-0 ">
        <IonToolbar color="primary">
          <IonButtons slot="start">{botonIzq}</IonButtons>
          <IonTitle style={{width: props.width, textAlign: props.textAlign , marginTop: props.marginTop}}>{props.titulo}</IonTitle>
          <IonButtons slot="end">{botonesDerecha}</IonButtons>
          <IonText color="light" style={{width: props.width, textAlign: props.textAlign }}><h3>{props.text}</h3></IonText>
          {props.children && (
            <IonText color="light" style={{width: props.width, textAlign: props.textAlign, marginBottom: props.marginBottom }}><h3>{props.children}</h3></IonText>
          )}
        </IonToolbar>
      </div>
    </IonHeader>
  );
};

export default Header;
